<template>
    <section>
        <div class="cbp-form">
            <h3>Review</h3>

            <div class="row mb-3">
                <div class="col-12 col-md-3">
                    <strong>Aircraft</strong>
                </div>
                <div class="col-12 col-md-9">
                    {{ store.aircraftTailNumber }}<br />
                    {{ store.aircraftYear }}
                    {{ store.aircraftMake }}
                    {{ store.aircraftModel }}<br />
                    {{ store.aircraftEngines == 1 ? 'Single' : 'Multi' }}-engine {{ store.engineType == 'P' ? 'Prop' : 'Jet'}}
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-12 col-md-3">
                    <strong>Maximum Landing Weight</strong>
                </div>
                <div class="col-12 col-md-9">
                    {{ store.aircraftMaxLandingWeight }}
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-12 col-md-3">
                    <strong>Landing Date</strong>
                </div>
                <div class="col-12 col-md-9">
                    {{ store.arrivalDate }}
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-12 col-md-3">
                    <strong>Amount Due</strong>
                </div>
                <div class="col-12 col-md-9">
                    ${{ store.estimatedFee}} USD
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-12 col-md-3">
                    <strong>Billing</strong>
                </div>
                <div class="col-12 col-md-9">
                    {{ store.paymentFirstName }} {{ store.paymentLastName }}<br />
                    {{ store.paymentAddress1 }}<br />
                    {{ store.paymentLocality }}, {{ store.paymentRegion }} {{ store.paymentPostalCode }} {{ store.paymentCountry }}<br />
                    {{ store.paymentEmail }}<br />
                    {{ store.paymentPhone }}
                </div>
            </div>

            <div class="row mb-3">
                <div class="col-sm-12">
                    <div class="d-flex flex-column align-items-center">
                        <recaptcha ref="recaptchaEl" :site-key="store.recaptchaSiteKey" @solved="recaptchaCallback"></recaptcha>
                    </div>
                </div>
            </div>

            <div v-if="paymentError" class="bg-white">
                <div class="text-danger">There was an error processing your payment. See details below:</div>
                <div class="text-danger">Status: {{ paymentErrorStatus }}</div>
                <div class="text-danger">Reason: {{ paymentErrorReason }}</div>
                <div class="text-danger">Message: {{ paymentErrorMessage }}</div>
            </div>

            <div class="text-center">
                <button type="button" class="btn btn-outline-primary me-3" @click="goBackToPage('PAYMENT')">Back</button>
                <button type="button" class="btn btn-primary" @click="submitPayment" :disabled="!submitEnabled">Submit Payment <i v-if="submittingPayment" class="fa-solid fa-spinner fa-spin"></i></button>
            </div>

        </div>
    </section>
</template>

<script setup>
    import { computed, ref } from 'vue';
    import { useStore } from './store';
    import recaptcha from '../../../components/recaptcha';

    const recaptchaResult = ref('');
    const recaptchaPassed = ref(false);
    const recaptchaEl = ref(null);

    const submittingPayment = ref(false);

    const paymentError = ref(false);
    const paymentErrorStatus = ref('');
    const paymentErrorReason = ref('');
    const paymentErrorMessage = ref('');

    const store = useStore();

    const submitEnabled = computed(() => {
        return (recaptchaPassed.value && !submittingPayment.value);
    });

    const emit = defineEmits(['goBackToPage', 'goToPage']);

    function goToPage(page) {
        emit('goToPage', page);
    }

    function goBackToPage(page) {
        emit('goBackToPage', page);
    }

    function recaptchaCallback(newState) {
        recaptchaPassed.value = !!newState;

        recaptchaResult.value = newState ? recaptchaEl.value.getResponse() : null;
    }

    function submitPayment() {

        var formData = new FormData();

        formData.append('g-recaptcha-response', recaptchaResult.value);
        formData.append('tailNumber', store.aircraftTailNumber);
        formData.append('aircraftYear', store.aircraftYear);
        formData.append('aircraftMake', store.aircraftMake);
        formData.append('aircraftModel', store.aircraftModel);
        formData.append('aircraftEngines', store.aircraftEngines);
        formData.append('engineType', store.engineType);
        formData.append('landedWeight', store.aircraftMaxLandingWeight);
        formData.append('landingTime', store.arrivalDate);
        formData.append('arrivalDate', store.arrivalDate);
        formData.append('paymentFirstName', store.paymentFirstName);
        formData.append('paymentLastName', store.paymentLastName);
        formData.append('paymentAddress1', store.paymentAddress1);
        formData.append('paymentLocality', store.paymentLocality);
        formData.append('paymentRegion', store.paymentRegion);
        formData.append('paymentPostalCode', store.paymentPostalCode);
        formData.append('paymentCountry', store.paymentCountry);
        formData.append('paymentPhone', store.paymentPhone);
        formData.append('paymentEmail', store.paymentEmail);
        formData.append('jwt', store.flexResponse);
        formData.append('emailToken', store.emailToken);

        submittingPayment.value = true;

        $.ajax({
            type: "POST",
            url: store.submitPaymentUrl,
            data: formData,
            processData: false,
            contentType: false,
            success: function (response) {

                if (response.Status == 'AUTHORIZED') {
                    store.paymentId = response.ResponseId;
                    submittingPayment.value = false;
                    goToPage('FINISH');
                }
                else {
                    paymentError.value = true;
                    paymentErrorStatus.value = response.Status;
                    paymentErrorReason.value = response.Reason;
                    paymentErrorMessage.value = response.Message;
                    submittingPayment.value = false;
                }

            }
        });
    }
</script>